import { Project } from '../graphql/types/project';

export let formatProject = (response: Array<Project>) => {
  let formatData = response.map((data: Project) => {
    return {
      id: data.id || '',
      name: data.name || '',
      googleSheetsURL: data.url || '',
      clientEmail: data.client.email || '',
      clientPassword: data.client.password || '',
    };
  });
  return formatData;
};
